import React, {Component} from 'react';
import banner from '../../static/images/banner.png';
import bigBanner from '../../static/images/bigBanner.jpg';
import PureRenderMixin from 'react-addons-pure-render-mixin'

class TopImage extends Component {
    constructor(props, context) {
        super(props, context);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {

        let img = banner;
        if (window.innerWidth > 1500) {
            img=bigBanner;
            return (

                <div id="hengTopImage" className="banner">
                    {/*<img style={{width: '100%',height:'200px'}} src={img} alt=""/>*/}
                    <img style={{width: '100%'}} src={img} alt=""/>
                </div>
            )
        }else{
            return (
                <div id="shuTopImage" className="banner">
                    {/*<img style={{width: '100%',height:'200px'}} src={img} alt=""/>*/}
                    <img style={{width: '100%'}} src={img} alt=""/>
                </div>
            )

        }



    }
}

export default TopImage;



// WEBPACK FOOTER //
// ./src/components/banner/TopImage.js